// extracted by mini-css-extract-plugin
export default {"executives_data":"Domain_executives_data__MQeRq","child_data":"Domain_child_data__G-QH-"};